import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEn from './langs/en';
import translationEl from './langs/el';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      enUS: { translation: translationEn },
      elGR: { translation: translationEl },
    },
    lng: 'enUS',
    ns: ['translation'],
    fallbackLng: 'enUS',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
